// import { CubeIcon } from "@heroicons/react/24/outline";
import CustomLoading from "../../../utils/LoadingIndicator/CustomLoading";
import useAdminDashboard from "./useAdminDashboard";

const ProductsComponent = () => {
  const { products, isLoading, errors } = useAdminDashboard();
  if (isLoading.products) {
    return <CustomLoading />;
  }
  if (errors.products) {
    return (
      <p className="text-xl font-semibold text-red-700">Some Error Occured</p>
    );
  }
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "EGP",
    }).format(amount);
  };

  const productStats = [
    {
      label: "Total Products",
      value: products?.totalProducts || 0,
      color: "text-blue-600",
    },
    {
      label: "Low Stock Products",
      value: products?.lowStockProducts?.length || 0,
      color: "text-red-600",
    },
  ];

  const topSellingProducts = (products?.topSellingProducts || []).slice(0, 3); // Top 3 top-selling products
  const productPerformance = (products?.productPerformance || []).slice(0, 3); // Top 3 performance entries

  return (
    <div className="p-3 bg-white rounded-md shadow-sm border border-gray-100">
      <h2 className="text-lg font-semibold text-gray-800 mb-2 leading-tight flex items-center">
        {/* <CubeIcon className="w-4 h-4 mr-1 text-gray-600" /> */}
        Product Analytics
      </h2>

      {/* Product Stats */}
      <div className="grid grid-cols-1 gap-1 mb-2">
        {productStats.map((stat, index) => (
          <div key={index} className="text-center p-2 bg-gray-50 rounded-sm">
            <p
              className={`text-base font-semibold ${stat.color} leading-tight`}
            >
              {stat.value}
            </p>
            <p className="text-xs text-gray-600">{stat.label}</p>
          </div>
        ))}
      </div>

      {/* Top Selling Products */}
      <div className="mb-2">
        <h3 className="text-sm font-semibold text-gray-800 mb-1 leading-tight flex items-center">
          {/* <Star className="w-4 h-4 mr-1 text-yellow-500" /> */}
          Top Selling Products
        </h3>
        <div className="space-y-1">
          {topSellingProducts.length > 0 ? (
            topSellingProducts.map((product) => {
              const performance = products?.productPerformance?.find(
                (p) => p._id === product._id
              );
              const revenue = performance
                ? performance.revenue
                : product.price * product.sold;
              return (
                <div
                  key={product._id}
                  className="flex items-center justify-between p-2 bg-gray-50 rounded-sm hover:bg-gray-100 transition-colors"
                >
                  <div className="flex items-center space-x-2">
                    <div className="w-6 h-6 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-xs">
                      {product.name?.charAt(0) || "P"}
                    </div>
                    <div>
                      <p className="font-semibold text-gray-800 text-sm leading-tight">
                        {product.name || "Unknown Product"}
                      </p>
                      <p className="text-xs text-gray-500 truncate max-w-[120px]">
                        {product._id.slice(-6)}
                      </p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="font-semibold text-green-600 text-sm leading-tight">
                      {formatCurrency(revenue)}
                    </p>
                    <p className="text-xs text-gray-500">{product.sold} sold</p>
                  </div>
                </div>
              );
            })
          ) : (
            <p className="text-gray-500 text-xs">No product data available</p>
          )}
        </div>
      </div>

      {/* Product Performance */}
      <div>
        <h3 className="text-sm font-semibold text-gray-800 mb-1 leading-tight flex items-center">
          {/* <Star className="w-4 h-4 mr-1 text-yellow-500" /> */}
          Product Performance
        </h3>
        <div className="space-y-1">
          {productPerformance.length > 0 ? (
            productPerformance.map((product) => (
              <div
                key={product._id}
                className="flex items-center justify-between p-2 bg-gray-50 rounded-sm hover:bg-gray-100 transition-colors"
              >
                <div className="flex items-center space-x-2">
                  <div className="w-6 h-6 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-xs">
                    {product.name?.charAt(0) || "P"}
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800 text-sm leading-tight">
                      {product.name || "Unknown Product"}
                    </p>
                    <p className="text-xs text-gray-500 truncate max-w-[120px]">
                      {product._id.slice(-6)}
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="font-semibold text-green-600 text-sm leading-tight">
                    {formatCurrency(product.revenue)}
                  </p>
                  <p className="text-xs text-gray-500">{product.sold} sold</p>
                </div>
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-xs">
              No performance data available
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductsComponent;
